import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import SignUp from '../views/SignUp.vue'
import SignIn from '../views/SignIn.vue'
import ActionLink from '../views/ActionLink.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			description: '',
			public: true
		}
	},
	{
		path: '/signin',
		name: 'signIn',
		component: SignIn,
		meta: {
			description: '',
			public: true
		}
	},
	{
		path: '/reset-password',
		name: 'resetPassword',
		component: () => import('../views/ResetPassword.vue'),
		meta: {
			public: true
		}
	},
	{
		path: '/signup',
		name: 'signUp',
		component: SignUp,
		meta: {
			public: true
		}
  },
  {
		path: '/actionlink',
		name: 'actionLink',
		component: ActionLink,
		meta: {
      public: true,
		}
  },
  {
		path: '/calendar/:id',
		name: 'calendar',
		component: () => import('../views/Calendar.vue'),
		meta: {
			public: true
		}
  },
  {
		path: '/select-school',
		name: 'selectSchool',
		component: () => import('../views/SelectSchool.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/messenger',
		name: 'messenger',
		component: () => import('../views/user/Messenger.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/class',
		name: 'yourClass',
		component: () => import('../views/user/Class.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/group',
		name: 'yourGroup',
		component: () => import('../views/user/Group.vue'),
		meta: {
			accessLevel: 1
		}
  },
	{
		path: '/user/profile',
		name: 'profile',
		component: () => import('../views/user/Profile.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/change-email',
		name: 'changeEmail',
		component: () => import('../views/user/ChangeEmail.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/schedule',
		name: 'schedule',
		component: () => import('../views/user/Schedule.vue'),
		meta: {
			accessLevel: 1
		}
  },
  {
		path: '/user/change-password',
		name: 'changePassword',
		component: () => import('../views/user/ChangePassword.vue'),
		meta: {
			accessLevel: 1
		}
	},
	{
		path: '/admin/userlist',
		name: 'userList',
		component: () => import('../views/admin/UserList.vue'),
		meta: {
			accessLevel: 5
		}
	},
	{
		path: '/admin/add-user',
		name: 'addUser',
		component: () => import('../views/admin/AddUser.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/add-user-bulk',
		name: 'addUserBulk',
		component: () => import('../views/admin/AddUserBulk.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/classlist',
		name: 'classList',
		component: () => import('../views/admin/ClassList.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/add-class',
		name: 'addClass',
		component: () => import('../views/admin/AddClass.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/edit-class/:classId',
		name: 'editClass',
		component: () => import('../views/admin/EditClass.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/grouplist',
		name: 'groupList',
		component: () => import('../views/admin/GroupList.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/add-group',
		name: 'addGroup',
		component: () => import('../views/admin/AddGroup.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/edit-group/:groupId',
		name: 'editGroup',
		component: () => import('../views/admin/EditGroup.vue'),
		meta: {
			accessLevel: 5
		}
  },
	{
		path: '/admin/edit-user/:uid',
		name: 'editUser',
		component: () => import('../views/admin/EditUser.vue'),
		meta: {
			accessLevel: 5
		}
  },
  {
		path: '/admin/settings',
		name: 'settings',
		component: () => import('../views/admin/Settings.vue'),
		meta: {
			accessLevel: 10
		}
  },
  {
		path: '/admin/add-school',
		name: 'addSchool',
		component: () => import('../views/admin/AddSchool.vue'),
		meta: {
			accessLevel: 10
		}
  },
  {
		path: '/admin/scheduler',
		name: 'scheduler',
		component: () => import('../views/admin/Scheduler.vue'),
		meta: {
			accessLevel: 5
		}
	},
  {
		path: '*',
		name: 'notFound',
		component: undefined,
		meta: {
			public: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'is-active exact-active',
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
	console.log('beforeEach')

	next()
})

router.afterEach(() => {
	console.log('afterEach')
})

export default router
